var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-state',{scopedSlots:_vm._u([{key:"caption",fn:function(){return [_vm._v("\n    このプランは現在お申し込みされていないため、解約できません。\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }